/**
 * Dependency Helper Functions
 * 
 * Low-level utilities for extracting dependency info and checking task completion.
 */

import { isStatusCompleted } from '../statusUtils';

/**
 * Helper to extract taskId from dependency (handles both string and object format)
 */
export function getDependencyTaskId(dep) {
  if (typeof dep === 'string') return dep;
  return dep?.taskId || null;
}

/**
 * Helper to extract branch from dependency (for decision node dependencies)
 */
export function getDependencyBranch(dep) {
  if (typeof dep === 'string') return null;
  return dep?.branch || null;
}

/**
 * Check if a task is effectively completed
 * A task is completed if:
 * 1. Its status is in the 'completed' category, OR
 * 2. It has a nested sprint with 100% progress
 * 
 * @param {Object} task - Task object
 * @param {Array} nestedSprints - Array of nested sprint objects
 * @param {Array} statuses - Custom statuses array
 * @returns {boolean}
 */
export function isTaskEffectivelyCompleted(task, nestedSprints = [], statuses = []) {
  // Direct completion - check if status is in the 'completed' category
  if (isStatusCompleted(task.status, statuses)) return true;
  
  // Check nested sprint completion
  if (task.nestedSprintId) {
    const nestedSprint = nestedSprints.find(ns => ns.id === task.nestedSprintId);
    if (nestedSprint && nestedSprint.progress === 100) {
      return true;
    }
  }
  
  return false;
}
